export const sortByNumber = (a, b) => {
    const regex = /[^-0-9]/g
    const numA = parseInt(a.replace(regex,'')) || 0
    const numB = parseInt(b.replace(regex,'')) || 0
    return numA >= numB ? 1 : -1;
}